import React, {PureComponent} from "react";

class ErrorBoundary extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            error: false
        }
    }

    static getDerivedStateFromError(error) {
        return { error: true };
    }

    componentDidCatch(error, errorInfo) {
        console.log(error, errorInfo)
    }

    render = () => {
        const { props, state } = this
        const { children } = props
        const { error } = state;

        if(error) {
            return <article className={"errorBoundary"}><div>Failed to load page</div></article>
        }

        return children;
    }
}

export default ErrorBoundary;
